if (!customElements.get('ma-engraving-field')) {
  customElements.define('ma-engraving-field', class extends HTMLElement {
    static drafts = new Map();
    connectedCallback() {
      this.abort = new AbortController();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.start(), {once:true, signal:this.abort.signal});
      else this.start();
    }
    start() {
      if (this.started || !this.isConnected) return;
      this.form = document.getElementById(this.dataset.formId);
      this.fields = this.querySelector('[data-ma-fields]');
      this.error = this.querySelector('[data-ma-error]');
      this.holder = this.querySelector('[data-ma-inputs]');
      this.summary = this.querySelector('[data-ma-summary]');
      if (!this.form || !this.fields || !this.error || !this.holder) return;
      this.config = JSON.parse(this.querySelector('[data-ma-config]').textContent);
      this.texts = JSON.parse(this.querySelector('[data-ma-texts]').textContent);
      this.started = true;
      this.segmenter = typeof Intl.Segmenter === 'function' ? new Intl.Segmenter(undefined, {granularity:'grapheme'}) : null;
      const opts = {signal:this.abort.signal};
      this.form.addEventListener('change', e => {if(e.target.name === 'id') this.sync();}, opts);
      this.form.addEventListener('submit', e => {
        if (!this.validate() || !this.form.reportValidity()) {e.preventDefault();e.stopImmediatePropagation();}
      }, {...opts,capture:true});
      this.sync();
    }
    disconnectedCallback() {this.abort?.abort();this.started=false;this.currentId=undefined;}
    characters(text) {return this.segmenter ? Array.from(this.segmenter.segment(text), p=>p.segment) : Array.from(text);}
    draftKey(key) {return this.dataset.productId + ':' + key;}
    clearError() {
      this.error.hidden=true; this.error.textContent='';
      this.holder.querySelectorAll('input').forEach(i=>{i.removeAttribute('aria-invalid');i.setCustomValidity('');});
    }
    showError(message,input) {
      this.hidden=false;this.error.hidden=false;this.error.textContent=message;
      if(input){input.setAttribute('aria-invalid','true');input.focus();}
      return false;
    }
    sync() {
      const id = this.form.elements.namedItem('id')?.value;
      if (id === this.currentId) return;
      this.currentId=id;
      this.clearError(); this.holder.replaceChildren();
      const conf=this.config[id];
      this.active=Boolean(conf?.fields?.length);
      this.hidden=!this.active;this.fields.hidden=!this.active;
      if(!this.active) return;
      conf.fields.forEach((field,index)=>{
        const wrap=document.createElement('div');wrap.className='ma-engraving__field';
        const row=document.createElement('div');row.className='ma-engraving__label-row';
        const label=document.createElement('label');
        const input=document.createElement('input');
        input.id='ma-text-'+this.dataset.formId+'-'+index;
        label.htmlFor=input.id;label.textContent=field.label+' *';
        const count=document.createElement('span');count.className='ma-engraving__count';count.setAttribute('aria-live','polite');
        input.className='ma-engraving__input';input.type='text';
        input.name='properties['+field.key+']';input.setAttribute('form',this.dataset.formId);
        input.required=true;input.autocomplete='off';input.spellcheck=false;
        input.dataset.max=String(field.max);input.dataset.key=field.key;
        input.placeholder=field.placeholder || (field.size?'LUNA':this.texts.placeholder);
        input.value=this.constructor.drafts.get(this.draftKey(field.key)) || '';
        const help=document.createElement('p');help.className='ma-engraving__help';
        help.id=input.id+'-help';input.setAttribute('aria-describedby',help.id+' '+this.error.id);
        help.textContent=this.texts.max_help.replace('__MAX__',field.max);
        const update=()=>{
          count.textContent=this.characters(input.value).length+' / '+field.max;
          this.constructor.drafts.set(this.draftKey(field.key),input.value);
          this.clearError();
        };
        input.addEventListener('input',update,{signal:this.abort.signal});
        input.addEventListener('compositionend',update,{signal:this.abort.signal});
        row.append(label,count);wrap.append(row,input,help);
        if(field.size) {
          const motifLabel=document.createElement('label');
          const select=document.createElement('select');
          select.id=input.id+'-motif';motifLabel.htmlFor=select.id;
          motifLabel.textContent=this.texts.motif.replace('__SIZE__',field.size);
          select.name='properties[Motiv '+field.size+']';select.setAttribute('form',this.dataset.formId);
          select.className='ma-engraving__input';
          for(const [value,text] of [['Ohne Motiv',this.texts.no_motif],['Pfote',this.texts.paw]]) {
            const option=document.createElement('option');option.value=value;option.textContent=text;select.append(option);
          }
          const key=this.draftKey('Motiv '+field.size);
          select.value=this.constructor.drafts.get(key) || 'Ohne Motiv';
          select.addEventListener('change',()=>this.constructor.drafts.set(key,select.value),{signal:this.abort.signal});
          wrap.append(motifLabel,select);
        }
        this.holder.append(wrap);update();
      });
      this.summary.textContent=this.texts.summary;
    }
    validate() {
      if(!this.started)this.start();
      if(!this.started)return false;
      this.sync();
      if(!Object.hasOwn(this.config,this.currentId))return this.showError(this.texts.choose_variant);
      if(!this.active)return true;
      for(const input of this.holder.querySelectorAll('input')) {
        const value=input.value.trim().normalize('NFC');
        if(!value)return this.showError(this.texts.fill_all,input);
        if(/[\r\n\t\u0000-\u001f\u007f]/u.test(value))return this.showError(this.texts.one_line,input);
        if(this.characters(value).length>Number(input.dataset.max))return this.showError(this.texts.too_long,input);
        if(!/^[\p{L}\p{M}\p{N} .,'’&!?():+\/-]+$/u.test(value))return this.showError(this.texts.characters,input);
        input.value=value;this.constructor.drafts.set(this.draftKey(input.dataset.key),value);
      }
      for(const select of this.holder.querySelectorAll('select')) {
        if(!['Ohne Motiv','Pfote'].includes(select.value))return this.showError(this.texts.characters);
      }
      this.clearError();return true;
    }
  });
}
